// External jQuery
import $ from 'jquery';
import '@babel/polyfill/dist/polyfill';
import { updateLocation, updateMarkers } from './_google_map';

let initialized = false;

$( document ).ready( function() {
	// eslint-disable-next-line no-console
	console.log( 'Hello! Everything is ready. ThemePlate!' );

	// Load the current location
	$( '#current-location' ).click( () => updateLocation() );
	$( '#reset-filters' ).click( () => {
		const url = new URL( window.location.origin + window.location.pathname );

		url.searchParams.delete( 'latitude' );
		url.searchParams.delete( 'longitude' );

		window.history.replaceState( null, null, url );
		$( '#alternate-address' ).val( '' );
		FWP.reset();
	} );
} ).on( 'facetwp-refresh', function () {
	$( '.ajax-loading' ).removeClass( 'd-none' );
} ).on( 'facetwp-loaded', function () {
	updateMarkers();
	$( '.ajax-loading' ).addClass( 'd-none' );

	if (! initialized) {
		initialized = true

		return
	}

    $( 'html, body' ).animate( {
        scrollTop: $( "#scolicare_markers" ).offset().top - ( $( '#masthead' ).outerHeight() || $( '#responsive-menu-pro-header-bar-items-container' ).outerHeight() )
    }, 800 );
} );
